export const NativeEventEmitterGameModesEnum = {
    MONEY: 'money',
};

export const NativeEventEmitterAccessabilityModesEnum = {
    ACCOUNT_BASED: 'basedOnPlayerAccount',
};
